import React from 'react';
import { Loader2 } from 'lucide-react';

interface EventComposerLoadingViewProps {
    containerStyle: React.CSSProperties;
}

/**
 * EventComposerLoadingView: High-fidelity tactical loading screen.
 * Used while the system hydrates the event payload.
 */
export const EventComposerLoadingView: React.FC<EventComposerLoadingViewProps> = ({ containerStyle }) => {
    return (
        <div 
            style={{ 
                ...containerStyle, 
                left: '50%', 
                transform: 'translateX(-50%)', 
                alignItems: 'center', 
                justifyContent: 'center', 
                backgroundColor: 'rgba(0,0,0,0.98)' 
            }} 
            className="animate-in fade-in duration-200"
        >
            <div style={{ textAlign: 'center' }}>
                <Loader2 size={32} color="#f29b11" className="animate-spin" style={{ marginBottom: '15px' }} />
                <p style={{ 
                    fontSize: '11px', 
                    fontWeight: '950', 
                    color: '#f29b11', 
                    letterSpacing: '2px',
                    textTransform: 'uppercase'
                }}>
                    Decrypting Event Data...
                </p>
            </div>
        </div>
    );
};
